import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {MenuItem} from 'primeng/api';
import {Router} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css', '../app.component.css']
})
export class MenuComponent implements OnInit {

  constructor(private realm: RealmService, private fb: FirebaseService, private route: Router) { }
  items: MenuItem[] = [];
  itm: any[] = [];
  selectedItem = '';
  page = '';
  ngOnInit() {
    this.realm.loginAsyncApp().then(() => {
      this.realm.getMenu();
    });
    this.realm.menus$.subscribe(data => {
      // @ts-ignore
      this.itm = data.data.optionsMenus;
      this.itm.forEach(value => {
        console.log(this.fb.getStringRC(value.titleRc));
        this.items.push({label: this.fb.getStringRC(value.titleRc), command: event => {this.selectedItem = value.titleRc; this.activeMenu(value.titleRc); }, styleClass: 'NoBorder' }, {separator: true});
      });
    });
  }
  activeMenu(event) {
    console.log(event);
    switch (event) {
      case 'menu_option_home_title': {
        this.route.navigate(['/home']);
        break;
      }
      case 'menu_option_profile_title': {
        this.route.navigate(['/profile']);
        break;
      }
      case 'menu_option_contact_title': {
        this.route.navigate(['/contact']);
        break;
      }
      case 'global_title_menu_one': {
        this.route.navigate(['/benefit']);
        break;
      }
      case 'global_title_menu_two': {
        this.route.navigate(['/authorization']);
        break;
      }
    }
    this.itm.forEach( val => {
      if (event === val) {
        //this.page = '<app-' + 'login' + '></app-' + 'login' + '>';
      }
    });
  }
}
